import type { GlossarySummary } from '@/lib/apis/sanity'
import { fetchGlossarySummaryPage } from '@/features/glossary/actions'

type GlossarySummaryPageParam = {
  slug: string
}

export function createGlossarySummaryPageQuery(
  slug: string,
  search: string,
  firstChar: string,
) {
  return {
    queryFn: ({ pageParam }: { pageParam: GlossarySummaryPageParam }) =>
      fetchGlossarySummaryPage({
        slug: pageParam.slug,
        search,
        firstChar,
      }),
    queryKey: ['glossary-summary', search, firstChar],
    initialPageParam: { slug },
    getNextPageParam: (
      lastPage: Array<GlossarySummary>,
    ): GlossarySummaryPageParam | null =>
      lastPage.length === 21 ? { slug: lastPage[20].slug.current } : null,
    staleTime: Infinity,
  }
}
